import EnumService from '../EnumService'

export default class OportunidadeLeiIncentivoEnumService extends EnumService{

    constructor(){
        super('enumLeiIncentivo');
    }
  
  }